/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Actions
 */

module.exports = {

    Angle: require('./Angle'),
    Call: require('./Call'),
    GetFirst: require('./GetFirst'),
    GridAlign: require('./GridAlign'),
    IncAlpha: require('./IncAlpha'),
    IncX: require('./IncX'),
    IncXY: require('./IncXY'),
    IncY: require('./IncY'),
    PlaceOnCircle: require('./PlaceOnCircle'),
    PlaceOnEllipse: require('./PlaceOnEllipse'),
    PlaceOnLine: require('./PlaceOnLine'),
    PlaceOnRectangle: require('./PlaceOnRectangle'),
    PlaceOnTriangle: require('./PlaceOnTriangle'),
    PlayAnimation: require('./PlayAnimation'),
    RandomCircle: require('./RandomCircle'),
    RandomEllipse: require('./RandomEllipse'),
    RandomLine: require('./RandomLine'),
    RandomRectangle: require('./RandomRectangle'),
    RandomTriangle: require('./RandomTriangle'),
    Rotate: require('./Rotate'),
    RotateAround: require('./RotateAround'),
    RotateAroundDistance: require('./RotateAroundDistance'),
    ScaleX: require('./ScaleX'),
    ScaleXY: require('./ScaleXY'),
    ScaleY: require('./ScaleY'),
    SetAlpha: require('./SetAlpha'),
    SetBlendMode: require('./SetBlendMode'),
    SetDepth: require('./SetDepth'),
    SetHitArea: require('./SetHitArea'),
    SetOrigin: require('./SetOrigin'),
    SetRotation: require('./SetRotation'),
    SetScale: require('./SetScale'),
    SetScaleX: require('./SetScaleX'),
    SetScaleY: require('./SetScaleY'),
    SetTint: require('./SetTint'),
    SetVisible: require('./SetVisible'),
    SetX: require('./SetX'),
    SetXY: require('./SetXY'),
    SetY: require('./SetY'),
    ShiftPosition: require('./ShiftPosition'),
    Shuffle: require('./Shuffle'),
    SmootherStep: require('./SmootherStep'),
    SmoothStep: require('./SmoothStep'),
    Spread: require('./Spread'),
    ToggleVisible: require('./ToggleVisible')

};



//////////////////
// WEBPACK FOOTER
// ./actions/index.js
// module id = 180
// module chunks = 0